import handleValueOrFunction from '@iez/lib/handle-value-or-function'
import { onBeforeUnmount, reactive } from '@vue/composition-api'

export const state = reactive({
  blockingMenu: null,
  scrollTop: null
})

export default () => {
  /**
   * {
   *   title,
   *   items: [
   *     {
   *        label,
   *        icon,
   *        onClick
   *     }
   *   ]
   * }
   */
  const set = blockingMenu => {
    handleValueOrFunction({
      valueOrFunction: blockingMenu,
      callback: blockingMenu => {
        state.blockingMenu = blockingMenu
      }
    })

    onBeforeUnmount(() => {
      state.blockingMenu = null
    })
  }

  const dismiss = () => {
    // state.model = false
  }

  /* let onCloseCallback = noop
  let onResultCallback = noop
  watch(
    () => state.model,
    model => {
      if (!model) {
        onCloseCallback()
        if (state.blockingMenu?.items) {
          onResultCallback(state.blockingMenu.items)
        }
      }
    }
  )
  const onClose = ({ callback }) => {
    onCloseCallback = callback
  }
  const onResult = ({ callback }) => {
    onResultCallback = callback
  } */

  return {
    set,
    dismiss,
    /* onClose,
    onResult */
  }
}
